module.exports = __webpack_public_path__ + "assets/img/video_fullscreen_share.684258ce.png";